import Decimal from 'decimal.js'

export function getMarginPercentage(
  amount: number | Decimal | null | undefined,
  unitcost: number | Decimal | null | undefined
) {
  const amountDecimal = new Decimal(amount || 0).toDecimalPlaces(2)
  const unitCostDecimal = new Decimal(unitcost || 0).toDecimalPlaces(2)

  if (amountDecimal.lte(0) || unitCostDecimal.lte(0)) {
    return new Decimal(0)
  }

  return amountDecimal.sub(unitCostDecimal).div(amountDecimal).mul(100).toDecimalPlaces(2)
}
